export class Config {
  static getGoogleSheetsUrl(): string {
    return this.isLocalDev()
      ? "http://54.171.10.113/loanWords2.2/google-sheets-proxy.php"
      : "google-sheets-proxy.php";
  }

  static isDummyData = false;

  static isLocalDev(): boolean {
    return window.location.href.indexOf("localhost") >= 0;
  }
}



// WEBPACK FOOTER //
// ./Config.ts